<template>
  <footer class="footer">
    <div class="inner">
      <div class="footer-left">
        <ul class="footer-nav">
          <li>
            <a type="link" href="#" @click="commonRedirect(maintenanceUrl)"
              >メンテナンス情報</a
            >
          </li>
          <li>
            <a
              type="link"
              href="#"
              @click="commonRedirect(siteAdministratorUrl)"
              >サイトの運営者</a
            >
          </li>
          <li>
            <a type="link" href="#" @click="commonRedirect(privacyPolicyUrl)"
              >プライバシーポリシー</a
            >
          </li>
          <li>
            <a type="link" href="#" @click="commonRedirect(sitePolicyUrl)"
              >サイトポリシー</a
            >
          </li>
          <li>
            <a type="link" href="#" @click="commonRedirect(termsOfUseUrl)"
              >利用規約</a
            >
          </li>
          <li>
            <a
              type="link"
              href="#"
              @click="commonRedirect(recommendedEnvironmentUrl)"
              >推奨環境</a
            >
          </li>
        </ul>
      </div>
      <div class="footer-right">
        <p class="copyright">Copyright © NTT DATA Japan Corporation</p>
      </div>
    </div>
  </footer>
</template>
<script>
import Common from "@/util/common.js";

export default {
  name: "LayoutFooter",
  data() {
    return {
      siteAdministratorUrl: Common.getSettingsValue("SiteAdministratorUrl"),
      privacyPolicyUrl: Common.getSettingsValue("PrivacyPolicyUrl"),
      sitePolicyUrl: Common.getSettingsValue("SitePolicyUrl"),
      termsOfUseUrl: Common.getSettingsValue("TermsOfUseUrl"),
      recommendedEnvironmentUrl: Common.getSettingsValue("RecommendedEnvironment"),
      maintenanceUrl: Common.getSettingsValue("MaintenanceUrl"),
    };
  },
  computed: {},
  created() {},
  methods: {
    // **********************************************
    // URL開く
    // **********************************************
    commonRedirect(path) {
      this.$cookies.set("pageUrl", path, "0");
      window.open(
        path,
        "",
        "width=1240,height=760,menubar=no,location=no,resizable=yes,scrollbars=yes,status=no"
      );
    },
    // **********************************************
    // URL開く
    // **********************************************
    commonRedirectMaintenance(path) {
      this.$cookies.set("pageUrl", path, "0");
      window.open(path);
    },
  },
};
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less"></style>
